<template>
  <component :is="innerButton ? 'button' : 'a'" :href="innerButton ? undefined : '#'" :type="innerType"
    :disabled="disabled" :id="id" :class="computedClass" @click.stop.prevent="click">
    <slot v-if="$slots.default" />
    <template v-else>{{ value }}</template>
  </component>
</template>

<script>
export default {
  name: 'LkButton',
  props: {
    id: String,
    color: String,
    value: String,
    button: Boolean,
    disabled: Boolean
  },
  computed: {
    computedClass() {
      const res = {}
      res['btn'] = true

      let color = this.color ? this.color : 'blue'
      if (color === 'dark') {
        color = 'blue'
      }
      if (color === 'light') {
        color = 'white'
      }
      if (color === 'green') {
        color = 'green'
      }
      if (this.disabled) {
        color = 'grey'
      }
      res[`btn-${color}`] = true

      return res
    },
    innerButton() {
      return this.button
    },
    innerType() {
      return 'button'
    }
  },
  methods: {
    click() {
      if (!this.disabled) {
        this.$emit('click')
      }
    }
  }
}
</script>
